export default "__VITE_ASSET__8f66b02e__"